<template>
  <router-view/>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      currentUser: state => state.user.user,
      activeSubscription: state => state.payments.activeSubscription,
      loadingActiveSubscription: state => state.payments.loadingActiveSubscription,
      isEnterpriseUser: state => state.payments.isEnterpriseUser,
      isSubscriptionAdmin: state => state.payments.isSubscriptionAdmin
    })
  },
  async mounted () {
    await store.dispatch('payments/getPaymentMethod')
  },
  watch: {
    isSubscriptionAdmin: function (val) {
      if (val === false) {
        this.$router.push('/subscription/my-plan')
      }
    },
    isEnterpriseUser: function (val) {
      if (!this.loadingActiveSubscription && this.activeSubscription && val) {
        this.$router.push('/subscription/my-plan')
      }
    }
  }
}
</script>

<style scoped>
</style>
